import { Component } from '@angular/core';

/** One flow's editor inside the order parser, so editing a flow from the Flows tab never leaves the parser. */
@Component({
  selector: 'lib-pdf-ai-parser-flow-details',
  standalone: false,
  templateUrl: './pdf-ai-parser-flow-details.component.html',
  styleUrl: '../pdf-ai-parser-flows/pdf-ai-parser-flows.component.scss'
})
export class PdfAiParserFlowDetailsComponent {}
